import { render, staticRenderFns } from "./newCompanyVehicle.vue?vue&type=template&id=2c63598a&"
import script from "./newCompanyVehicle.vue?vue&type=script&lang=js&"
export * from "./newCompanyVehicle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports